export type HomeInsightTone = "high" | "medium" | "opportunity" | "breach";

export type FindingType = "opportunity" | "breach" | "risk";

export type HomeInsight = {
    id: string;
    type: FindingType;
    tone: HomeInsightTone;
    eyebrow?: string;
    eyebrow_sub?: string;
    title: string;
    description: string;
    impactLabel?: string;
    impactValue?: string;
    recommendation?: string;
    confidence?: string;
    actionLabel: string;
};

export const homeFreshness = {
    analysisLabel: "Sovra analysed your latest data today at 7:42 AM",
    dataPeriodLabel: "Data current to 20 Sep"
};

export const homeCommercialRequirements = [
    "Maintain a minimum gross margin of 32% across all promotional activities.",
    "Do not exceed the annual retail investment budget of $1.5M for FY26.",
    "Do not exceed the annual retail investment budget of $875K for Woolworths.",
    "No product should be promoted for more than 2 consecutive weeks.",
    "Allow a minimum 4-week gap between promotional campaigns for the same SKU."
];

export const homeAnalysisActivity = "Sovra is preparing your Coles meeting brief...";

export const homeAnalysisTopics = [
    "Sales performance",
    "Margin",
    "Pricing",
    "Promotions",
    "Distribution",
    "Upcoming activity"
];

export const homeSuggestedQuestions = [
    "What changed in the business this week?",
    "Why is promo performance declining at Woolworths?",
    "Where are we losing margin?",
    "Why is Lemon Lime 330ml declining at Coles?",
    "Which promotions are below the margin guardrail?",
    "Where should we reallocate promotional investment?"
];

export const homeFindings: HomeInsight[] = [
    {
        id: "woolworths-promo-performance",
        type: "breach",
        tone: "breach",
        eyebrow: "Requirement breach",
        eyebrow_sub: "High Priority · All Retailers",
        title: "Promo performance has deteriorated",
        description: "The latest Raspberry 330ml promotion delivered 18% lower incremental volume than comparable promotions.",
        impactLabel: "Potential impact:",
        impactValue: "-$42k gross profit",
        recommendation: "Review the next scheduled promotion before committing investment.",
        confidence: "87% confidence",
        actionLabel: "Review decision"
    },
    {
        id: "coles-base-velocity",
        type: "risk",
        tone: "high",
        eyebrow: "Risk",
        eyebrow_sub: "High Priority · Retailer A",
        title: "Base velocity is declining",
        description: "Lemon Lime 330ml velocity has declined for three consecutive weeks despite stable distribution.",
        impactLabel: "Potential impact:",
        impactValue: "-$31k revenue over the next 8 weeks",
        actionLabel: "Investigate"
    },
    {
        id: "kombucha-pricing",
        type: "opportunity",
        tone: "opportunity",
        eyebrow: "Opportunity",
        eyebrow_sub: "Retailer A · North & Pine",
        title: "Pricing opportunity",
        description: "Potential headroom exists to increase the base price of Kombucha 4-Pack by 3–4% at Coles.",
        impactLabel: "Estimated opportunity:",
        impactValue: "+$68k annual gross profit",
        actionLabel: "Explore opportunity"
    },
    {
        id: "margin-guardrail",
        type: "risk",
        tone: "medium",
        eyebrow: "High priority · All retailers",
        eyebrow_sub: "Medium Priority · Retailer B",
        title: "Upcoming promotion breaches margin guardrail",
        description: "The planned 25% discount on Ginger 4-Pack is forecast to take gross margin below the approved 32% floor.",
        actionLabel: "Simulate alternatives"
    },
    {
        id: "reallocate-promotion",
        type: "opportunity",
        tone: "opportunity",
        eyebrow: "Opportunity",
        eyebrow_sub: "All Retailers · North & Pine",
        title: "Reallocate promotional investment",
        description: "Moving $25k of planned promotional investment from SKU X to SKU Y is projected to improve gross profit.",
        impactLabel: "Estimated opportunity:",
        impactValue: "+$18k gross profit",
        actionLabel: "Simulate"
    }
];
